import React from "react";
import { Image, Rect } from "react-konva";
import useImage from "use-image";
// import { getCrop } from "./konvaProcessor";

function getCropMosaic(imageWidth, imageHeight, renderResolution) {
  const aspectRatio = renderResolution.width / renderResolution.height;
  const imageRatio = imageWidth / imageHeight;
  // console.log(renderResolution.width / imageRatio);

  let newWidth;
  let newHeight;
  // console.log(aspectRatio, imageRatio);
  if (aspectRatio > imageRatio) {
    if (aspectRatio > 3) {
      console.log("aspectRatio > 3");
      newWidth = imageWidth;
      newHeight = renderResolution?.height;
    } else {
      // console.log("aspectRatio < 3");
      newWidth = renderResolution.width;
      newHeight = renderResolution.width / imageRatio;
    }
  } else {
    newWidth = renderResolution.height * imageRatio;
    newHeight = renderResolution.height;
  }
  //
  // const x = (newWidth - renderResolution.width) / 2;
  // const y = (newHeight - renderResolution.height) / 2;

  // console.log(newWidth, newHeight, x, y);

  return {
    x: 0, // Adjusting x to ensure proper centering
    y: 0, // Adjusting y to ensure proper centering
    width: newWidth,
    height: newHeight,
  };
}

export const MosaicMask = ({ item, renderResolution }) => {
  const [maskImage] = useImage(item?.mask, "anonymous");
  const [colorImage] = useImage(item?.color.img, "anonymous");
  const maskRef = React.useRef();
  const colorRef = React.useRef();

  React.useEffect(() => {
    if (maskImage) {
      maskRef.current?.cache();
    }
    if (colorImage) {
      colorRef.current?.cache();
      colorRef.current?.drawHitFromCache();
    }
  }, [maskImage, colorImage, renderResolution]);

  const crop = getCropMosaic(
    colorImage?.width,
    colorImage?.height,
    renderResolution,
  );

  const scale = renderResolution?.width > 100 ? 0.6 : 0.3;
  // console.log(scale);
  // console.log(renderResolution);

  return (
    <React.Fragment>
      <Rect
        width={renderResolution?.width}
        height={renderResolution?.height}
        fillPatternImage={maskImage}
        fillPatternRepeat="repeat"
        fillPatternScaleX={scale}
        fillPatternScaleY={scale}
        opacity={item.color?.img === "" ? 0 : 1}
      />

      <Image
        ref={colorRef}
        image={colorImage}
        crop={crop}
        globalCompositeOperation="source-atop"
        applyCache
        applyHitFromCache
        width={renderResolution?.width}
        height={renderResolution?.height}
      />
    </React.Fragment>
  );
};
